import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useNotifications } from "../contexts/NotificationContext";

const TIPO_ICON = {
  RESERVA: { icon: "fa-calendar-check",        color: "#4ade80" },
  PAGO:    { icon: "fa-money-bill-transfer",   color: "#f59e0b" },
  AVISO:   { icon: "fa-bell",                  color: "#38bdf8" },
  GENERAL: { icon: "fa-circle-info",           color: "#a78bfa" },
};

const AUTO_DISMISS = 8000;

// Pila de toasts para notificaciones que acaban de llegar (RESERVA/PAGO/AVISO),
// montada una sola vez en Layout — así aplica igual para el admin y el residente,
// sin importar en qué pantalla estén.
export default function NotificationToasts() {
  const { justArrived, dismissArrived, markOneRead } = useNotifications();
  const navigate = useNavigate();
  const [visible, setVisible] = useState([]);

  useEffect(() => {
    if (justArrived.length === 0) return;
    justArrived.forEach(n => {
      setVisible(prev => (prev.some(v => v.id === n.id) ? prev : [...prev.slice(-2), n]));
      dismissArrived(n.id);
      setTimeout(() => {
        setVisible(prev => prev.filter(v => v.id !== n.id));
      }, AUTO_DISMISS);
    });
  }, [justArrived, dismissArrived]);

  async function handleClick(n) {
    setVisible(prev => prev.filter(v => v.id !== n.id));
    const r = await markOneRead(n.id);
    // De otro condominio (cambiaron de condominio en otra pestaña): no se
    // navega, porque la pantalla destino no encontraría el registro.
    if (r?.otroCondominio) return;
    if (n.link) {
      if (window.location.pathname === n.link) navigate(0);
      else navigate(n.link);
    }
  }

  if (visible.length === 0) return null;

  return (
    <div style={{
      position: "fixed", bottom: 24, right: 24, zIndex: 9999,
      display: "flex", flexDirection: "column", gap: 10,
      pointerEvents: "none",
    }}>
      <style>{`@keyframes notifToastIn{from{opacity:0;transform:translateX(20px)}to{opacity:1;transform:none}}`}</style>
      {visible.map(n => {
        const ti = TIPO_ICON[n.tipo] || TIPO_ICON.GENERAL;
        return (
          <div key={n.id} onClick={() => handleClick(n)} style={{
            pointerEvents: "all", position: "relative",
            background: "var(--bg-card)", border: `1px solid ${ti.color}55`,
            borderLeft: `4px solid ${ti.color}`, borderRadius: 12,
            padding: "14px 16px", width: 300,
            boxShadow: `0 8px 28px rgba(0,0,0,.28), 0 0 0 1px ${ti.color}22`,
            cursor: "pointer", display: "flex", alignItems: "flex-start", gap: 12,
            animation: "notifToastIn .25s ease both",
          }}>
            <div style={{
              width: 36, height: 36, borderRadius: 9, flexShrink: 0,
              background: `${ti.color}18`, border: `1px solid ${ti.color}44`,
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <i className={`fa-solid ${ti.icon}`} style={{ color: ti.color, fontSize: 15 }} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: "var(--text-primary)", lineHeight: 1.3 }}>
                {n.titulo}
              </p>
              {n.cuerpo && (
                <p style={{ margin: "3px 0 0", fontSize: 12, color: "var(--text-secondary)", lineHeight: 1.45 }}>
                  {n.cuerpo}
                </p>
              )}
              <span style={{ fontSize: 11, color: ti.color, fontWeight: 700, marginTop: 4, display: "inline-block" }}>
                Toca para ver →
              </span>
            </div>
            <button
              onClick={e => { e.stopPropagation(); setVisible(prev => prev.filter(v => v.id !== n.id)); }}
              style={{
                position: "absolute", top: 8, right: 8,
                background: "none", border: "none", cursor: "pointer",
                color: "var(--text-secondary)", fontSize: 13, lineHeight: 1,
                padding: 4, borderRadius: 5,
              }}
            >
              <i className="fa-solid fa-xmark" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
